<template>
  <div :class="classes()">
    <template v-for="(_, slot) in $slots">
      <div
        ref="item"
        :class="`${el}__item${itemClass ? ` ${itemClass}` : ''}`"
        :key="`InViewAnimation-${slot}`"
        :style="`z-index: ${Object.keys($slots).length - slot + 1} ; transition-delay: ${
          0.1 * slot + delay * 0.1
        }s;`"
      >
        <slot :name="slot" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'InViewAnimation',
  props: {
    itemClass: {
      type: String,
      default: null,
    },
    delay: {
      type: Number,
      default: 0,
    }, // wait in slot items
  },
  watch: {
    $route: function () {
      this.loaded = false;
      this.setLoaded();
    },
  },
  data() {
    return {
      loaded: false,
      el: 'c-inViewAnimation',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--loaded`]: this.loaded,
        };
      },
    };
  },
  mounted() {
    this.setLoaded();
    this.removeInlineStylesAndClasses();
  },
  methods: {
    setLoaded() {
      setTimeout(() => {
        this.loaded = true;
      }, 10);
    },

    removeInlineStylesAndClasses() {
      const delay = 500; // medium delay
      const length = Object.keys(this.$slots).length;
      const timeout = delay * length;

      setTimeout(() => {
        this.$refs.item?.map((el) => {
          el.removeAttribute('style');
          el.removeAttribute('class');
        });
      }, timeout);
    },
  },
};
</script>
